<template>
    <div>
        <div class="prestige-txt">{{lbl.profile.prestige_club}}</div>
        <div class="prestige-txt">{{prestigeLvl}}</div>
        <div class="box-id">
            <div class="txt-size-id">{{privilegeTxt}}{{privilegeId}}</div>
            <div v-clipboard:copy="privilegeId"
                v-clipboard:success="onCopyCode"
                v-clipboard:error="onErrorCode">
                <div class="txt-size-copy">
                    <img class="img-copy" src="@/assets/icon/ic-copy.svg" alt="">
                    <div class="txt-copy">{{ lbl.serial.copy_code }}</div>
                </div>
            </div>
        </div>
        <div id="profile_card"
            :class="{'profile-ambassador': isAmbassador}">

            <div id="profile_card_wrapper">
                <!-- <span id="profile_crown"
                    v-if="isAmbassador">
                    <img class="img-fluid" src="../asset/ambassador@3x.png">
                </span>
                <img class="img-fluid" v-if="tier == 'c'" src="../asset/Classic.png" />
                <img class="img-fluid" v-if="tier == 's'" src="../asset/Silver.png" />
                <img class="img-fluid" v-if="tier == 'g'" src="../asset/Gold.png" />
                <img class="img-fluid" v-if="tier == 'p'" src="../asset/Plattinum.png" /> -->
                <img class="img-fluid" :src="getCardImg()" />
            </div>
        </div>
    </div>

</template>
<script>
import Vue from 'vue';
//mixin
import AccountMixin from '@/mixin/AccountMixin.js';
import VueClipboard from 'vue-clipboard2'
export default {
    name: 'ProfileCard',
    mixins: [AccountMixin],
    props: {
        lbl: Object,
        privilegeList: Object
    },
    data: function () {
        return {
            welcomeConfig: {},
            privilegeTxt: '',
            privilegeId: null
        }
    },
    created: function () {
        VueClipboard.config.autoSetContainer = true;
        Vue.use(VueClipboard);

        this.prestigeLvl = this.lbl.profile.tier_lvl[this.tier];
        this.privilegeTxt = this.lbl.profile.privilege_id;
        this.getUserId();
        // if (this.isAmbassador)
        //     this.prestigeLvl += ` ${this.lbl.profile.ambassador}`;
    },
    methods: {
        //copy clipboard
        onCopyCode: function (e) {
            console.log('copied', e.text);
        },
        onErrorCode: function (e) {
            console.log('failed', e);
        },
        getCardImg: function () {
            var blob_path = `${Vue.bzbsConfig.bzbsBlobUrl}/aia/prestige/profile_card`;
            return `${blob_path}/${this.tier}`;
        },
        getUserId: function() {
            const spliceUserId = this.privilegeList.Tier.PRIVILEGE_ID;
            this.privilegeId = spliceUserId.substr(length-12);
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";

.prestige-txt {
    color: $prestige_font_color;
    font-size: 1.6rem;
    // font-family: $heading;
    text-align: center;
    // line-height: 1;
}

.box-id {
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: linear-gradient(to right, #c7bca0, #eee9de 51%, #c7bca0);
    width: 288px;
    margin: auto;
    border-radius: 10px;
    padding: 10px;

    .txt-size-id {
        color: $prestige_font_color;
        // font-family: $heading;
        text-align: center;
        // line-height: 1;
        font-size: 1.563rem;
        padding-right: 8px;
    }
    .txt-size-copy {
        display: flex;
        justify-content: center;
        align-items: center;
        color: $prestige_font_color;
        // font-family: $heading;
        text-align: center;
        // line-height: 1;
        font-size: 1.25rem;
        padding: 1px 10px;
        border: 1px solid #333d47;
        border-radius: 4px;

        .img-copy {
            width: 15px;
            height: 15px;
        }
        .txt-copy {
            padding-left: 4px;
        }
    }
}

#profile_card {
    width: 100%;
    padding: 25px;

    #profile_card_wrapper {
        position: relative;

        #profile_crown {
            position: absolute;
            top: -32px;
            left: -22px;
            width: 62px;

            @media(max-width: $max-width-mini-mobile){
                top: -26px;
                left: -18px;
                width: 50px;
            }
        }

        img {
            border-radius: 10px;
        }
    }
}
</style>
